export enum PatientSource {
  SELF_SCHEDULING = "SELF_SCHEDULING",
  CALL = "CALL",
  TEXT = "TEXT",
  MANUALLY_CREATED = "MANUALLY_CREATED",
  UPLOADED_FROM_FILE = "UPLOADED_FROM_FILE",
  FORM = "FORM",
  SEED_DATA = "SEED_DATA",
  DEMO = "DEMO",
  EXTERNAL_INTEGRATION = "EXTERNAL_INTEGRATION",
  REFERRAL = "REFERRAL",
  WEB_CHAT = "WEB_CHAT",
  META_ADS = "META_ADS",
  GOOGLE_ADS = "GOOGLE_ADS",
  WEB_FORM = "WEB_FORM",
  SOCIALS = "SOCIALS",
  IMPORTED_CRM = "IMPORTED_CRM",
  OTHER = "OTHER",
}
